import React from 'react';
import times from 'lodash/times';
import { HtmlTable } from '../../../../CommonComponents/OPL/HtmlTable/HtmlTable';
import { WorkflowComponentProps } from '../../../../Workflow/Workflow.meta';
import { ColumnHeader } from '../../../OtherAssets/OtherAssets.meta';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { Button } from '../../../../CommonComponents/OPL/Button/Button';

export const COLUMN_HEADERS: ColumnHeader[] = [
  { text: 'Asset Type' },
  { text: 'Owner' },
  { text: 'Market Value', align: 'right' },
];

interface Props {
  title: string;
  children: React.ReactNode;
  headerActions: React.ReactNode;
  onAddAnotherGrant(): void;
  workflowProps?: WorkflowComponentProps;
}

export const StockOptionsTable = ({
  title,
  headerActions,
  children,
  onAddAnotherGrant,
  workflowProps,
}: Props) => {
  return (
    <HtmlTable variant={workflowProps && 'bordered'}>
      <table style={{ tableLayout: 'fixed' }}>
        <colgroup>
          {times(COLUMN_HEADERS.length).map(key => (
            <col key={key} />
          ))}

          <col style={{ width: 126 }} />
        </colgroup>

        <caption>
          <Box display="flex" alignItems="center" justifyContent="space-between">
            {title}
            {headerActions}
          </Box>
        </caption>

        <thead>
          <tr>
            {COLUMN_HEADERS.map(({ text, align }) => (
              <th key={text}>
                <Text variant="smallCaps" textAlign={align || 'left'}>
                  {text}
                </Text>
              </th>
            ))}

            <th aria-label={`${title} Actions`}>&nbsp;</th>
          </tr>
        </thead>

        <tbody>{children}</tbody>
      </table>

      <Box px="16" py="12" borderTop="1px solid" borderColor="neutral.200">
        <Button variant="link" leftIcon="fas fa-plus" onClick={onAddAnotherGrant}>
          Add Another Stock Grant
        </Button>
      </Box>
    </HtmlTable>
  );
};
